import React, { useContext, useRef, useState, useEffect } from 'react';
import Button from "react-bootstrap/Button";
import quizInstanceAdminStatusContext from '../context/quizInstanceAdminStatusContext';
import QuizApi from '../QuizApi';

export default function QuizAdminRoomMode() {

  const ctx = useContext(quizInstanceAdminStatusContext);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [advancing, setAdvancing] = useState(false);

  const questionList = ctx.quizInfo.questionList || [];
  const currentIndex = ctx.quizInfo.config?.currentQuestionIndex ?? 0;
  const question = questionList[currentIndex] || null;

  const audioTrack = question
    ? (question.externalMediaList || []).find(
        m => m.mimeType === "audio/mpeg" || (m.mimeType || "").startsWith("audio/")
      )
    : null;

  // Stop audio when question changes
  useEffect(() => {
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex]);

  const setQuestion = async (index) => {
    if (advancing) return;
    setAdvancing(true);
    await QuizApi.quizInstanceRoomModeSetQuestion(ctx.quizInfo.id, index);
    setAdvancing(false);
  };

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.currentTime = 0;
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <div id="quizAdminLobby">
      <div className="d-flex justify-content-center align-items-start h-100 pt-4">
        <div style={{ maxWidth: '520px', width: '100%', padding: '0 16px' }}>

          <div style={{ color: '#7B7C6A', fontWeight: 700, fontSize: '13px', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>
            Samlat läge
          </div>
          <div style={{ fontSize: '24px', fontWeight: 700, marginBottom: '24px' }}>
            Fråga {currentIndex + 1} / {questionList.length}
          </div>

          {audioTrack && (
            <audio
              ref={audioRef}
              src={audioTrack.url}
              onEnded={() => setIsPlaying(false)}
              style={{ display: 'none' }}
            />
          )}

          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
            <Button
              className="btn-quizPrimaryDark"
              disabled={currentIndex === 0 || advancing}
              onClick={() => setQuestion(currentIndex - 1)}
            >
              ← Föregående
            </Button>

            <Button
              className="btn-quizPrimaryDark"
              disabled={!audioTrack || advancing}
              onClick={togglePlay}
              style={{ minWidth: '100px' }}
            >
              {isPlaying ? '⏸ Pausa' : '▶ Spela'}
            </Button>

            <Button
              className="btn-quizPrimaryDark"
              disabled={currentIndex >= questionList.length - 1 || advancing}
              onClick={() => setQuestion(currentIndex + 1)}
            >
              Nästa →
            </Button>

            <Button
              style={{ backgroundColor: '#c0392b', borderColor: '#c0392b', color: '#fff' }}
              onClick={() => ctx.callbacks.setForceQuizEnd(true)}
            >
              Avsluta
            </Button>
          </div>

          {!ctx.isCourseSession && (
            <div className="mt-4" style={{ fontSize: '13px', color: '#888' }}>
              Deltagarna svarar på <strong>{ctx.quizUrl}</strong>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
